import { authenticatedFetch } from './authApi'

const API_BASE_URL = (import.meta.env.DEV && import.meta.env.VITE_USE_API_PROXY)
  ? ''
  : (import.meta.env.VITE_API_GATEWAY_URL || 'http://moneybridge-feature-api.australiaeast.azurecontainer.io:8000')

export interface CustomerProfile {
  first_name?: string
  last_name?: string
  phone_number?: string
  date_of_birth?: string
  address?: string
  annual_income?: number
  employment_status?: string
  dependants?: number
}

export interface BrokerProfile {
  first_name?: string
  last_name?: string
  business_name?: string
  license_number?: string
  years_experience?: number
  specialization?: string
  bio?: string
  photo_url?: string
  rating?: number
  is_accepting_clients?: boolean
}

export interface ProfileCompletion {
  completion_percent: number
  missing: string[]
}

function getHeaders(accessToken: string): HeadersInit {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${accessToken}`,
  }
}

export const profileApi = {
  async getCustomerProfile(accessToken: string): Promise<{ profile: CustomerProfile }> {
    const res = await authenticatedFetch(`${API_BASE_URL}/api/profile/customer`, {
      headers: getHeaders(accessToken),
    })
    if (!res.ok) throw new Error('Failed to fetch profile')
    return res.json()
  },

  async putCustomerProfile(
    accessToken: string,
    data: Partial<CustomerProfile>
  ): Promise<{ success: boolean }> {
    const res = await authenticatedFetch(`${API_BASE_URL}/api/profile/customer`, {
      method: 'PUT',
      headers: getHeaders(accessToken),
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to save profile')
    return res.json()
  },

  async getBrokerProfile(accessToken: string): Promise<{ profile: BrokerProfile }> {
    const res = await authenticatedFetch(`${API_BASE_URL}/api/profile/broker`, {
      headers: getHeaders(accessToken),
    })
    if (!res.ok) throw new Error('Failed to fetch profile')
    return res.json()
  },

  async putBrokerProfile(
    accessToken: string,
    data: Partial<BrokerProfile>
  ): Promise<{ success: boolean }> {
    const res = await authenticatedFetch(`${API_BASE_URL}/api/profile/broker`, {
      method: 'PUT',
      headers: getHeaders(accessToken),
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to save profile')
    return res.json()
  },

  async getProfileCompletion(accessToken: string): Promise<ProfileCompletion> {
    const res = await authenticatedFetch(`${API_BASE_URL}/api/profile/completion`, {
      headers: getHeaders(accessToken),
    })
    if (!res.ok) throw new Error('Failed to fetch completion')
    return res.json()
  },
}
